import { makeQuery } from "src/queries/makeQuery";
import type { PipelineRun, PipelineRunResponse } from "./pipelineRuns.types";

// Sort in descending order (newest first)
const sortRunsDescending = (runs: PipelineRun[]) =>
  runs.toSorted(
    (a, b) => new Date(b.app_pit).getTime() - new Date(a.app_pit).getTime()
  );

export const useQueryPipelineRun = makeQuery<PipelineRunResponse>(
  (p) => `/api/envs/${p.env_name}/apps/${p.app_name}/runs/${p.app_pit}`
);

export const useQueryRuns = makeQuery<PipelineRun[], PipelineRun[]>(
  (p) => `/api/envs/${p.env_name}/apps/${p.app_name}/runs`,
  {
    queryParams: ["timeWindow"],
    select: sortRunsDescending,
  }
);
